module.exports = __webpack_public_path__ + "static/media/FT-FONDO-AI.1ce7d448.jpg";